var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"h-100"},[(_vm.dataTableReady)?[_c('datatable',{attrs:{"tcols":_vm.cols,"trows":_vm.rows,"tconfig":_vm.config,"pages_chunk":_vm.pages_chunk,"rows_count":_vm.rows_count}})]:[_c('loader')]],2)}
var staticRenderFns = []

export { render, staticRenderFns }